import React from 'react';

export default function InviteStatus({ status }) {
    switch (status) {
    case 'PENDING':
        return (
            <p>
                                Pending
            </p>
        );
    case 'IN_PROGRESS':
        return (
            <p>
                                In Progress
            </p>
        );
    case 'ACCEPTED':
        return (
            <p className='success-text'>
                                Accepted
            </p>
        );
    default:
        return status;
    }
}
